import React from 'react';
import styles from '../NDAGenerator.module.scss';
import MarkupViewer from '../MarkupViewer/MarkupViewer';
import { ComparisonResult } from '../ComparisonResult/ComparisonResult';
import EnhancedComparisonResult from '../EnhancedComparisonResult/EnhancedComparisonResult';
import { ndaComplianceService } from '../../../../utils/ndaComplianceService';

export interface ResultsPanelProps {
  complianceAnalysis: any;
  hasDetailedComparison: boolean;
  showComparisonResult: boolean;
  enhancedResult: any;
  customerNDAName: string;
  comparisonId: string | null;
  onCloseEnhanced: () => void;
  onStartNewReview: () => void;
}

const ResultsPanel: React.FC<ResultsPanelProps> = ({
  complianceAnalysis,
  hasDetailedComparison,
  showComparisonResult,
  enhancedResult,
  customerNDAName,
  comparisonId,
  onCloseEnhanced,
  onStartNewReview
}) => {
  return (
    <>
      {complianceAnalysis.sideBySideComparison && hasDetailedComparison && (
        <MarkupViewer
          comparison={ndaComplianceService.convertToDocumentComparison(
            complianceAnalysis.sideBySideComparison
          )}
          customerNDAName={customerNDAName}
        />
      )}
      {(showComparisonResult || enhancedResult) && (
        <div className={styles.reportSection}>
          <div className={styles.reportHeader}>
            <h3 className={styles.reportTitle}>Compliance Summary Report</h3>
          </div>
          {enhancedResult ? (
            <EnhancedComparisonResult
              result={enhancedResult}
              analysisMethod={'manual'}
              onClose={onCloseEnhanced}
              onStartNewReview={onStartNewReview}
            />
          ) : (
            <ComparisonResult
              comparisonId={(comparisonId as string) || 'unknown'}
              isProcessing={['/null', 'null?'].some((p) => {
                const values = Object.values(
                  complianceAnalysis.comparisonResultFiles || {}
                );
                return values.some((v) => {
                  const str = typeof v === 'string' ? v : JSON.stringify(v);
                  return str.includes(p);
                });
              })}
              initialReport={
                complianceAnalysis.comparisonResultFiles as Record<
                  string,
                  unknown
                >
              }
            />
          )}
        </div>
      )}
      {!hasDetailedComparison && !(showComparisonResult || enhancedResult) && (
        <div className={styles.noComparison}>
          <p>
            Document comparison not available. Please try uploading your
            document again.
          </p>
        </div>
      )}
    </>
  );
};

export default ResultsPanel;
